var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,{tag:"component",attrs:{"active":_vm.active}},[_vm._t("default",null,{"active":_vm.active,"setActive":_vm.setActive})],2)}
var staticRenderFns = []

export { render, staticRenderFns }